const INVALID_FILENAME_CHARS = /[<>:"/\\|?*\u0000-\u001f]/g;
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function sanitizeFilenamePart(value, fallback = '') {
  const text = String(value == null ? '' : value)
    .replace(INVALID_FILENAME_CHARS, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[. ]+$/g, '');

  return text || fallback;
}

function parseScheduleDate(value) {
  if (!value) return null;

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const text = String(value).trim();
  if (!text) return null;

  if (DATE_ONLY.test(text)) {
    const [year, month, day] = text.split('-').map(Number);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatExecutionDate(value) {
  const parsed = parseScheduleDate(value);
  if (!parsed) return '';

  return new Intl.DateTimeFormat('id-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(parsed);
}

export function formatBatchExecutionDate(schedules = []) {
  const uniqueDates = [];
  const seen = new Set();

  (Array.isArray(schedules) ? schedules : []).forEach((schedule) => {
    const rawDate = schedule?.date || schedule?.start_date || schedule;
    const parsed = parseScheduleDate(rawDate);
    if (!parsed) return;

    const key = `${parsed.getFullYear()}-${parsed.getMonth()}-${parsed.getDate()}`;
    if (seen.has(key)) return;
    seen.add(key);
    uniqueDates.push(parsed);
  });

  uniqueDates.sort((a, b) => a.getTime() - b.getTime());

  if (uniqueDates.length === 0) return '';
  if (uniqueDates.length === 1) return formatExecutionDate(uniqueDates[0]);

  return `${formatExecutionDate(uniqueDates[0])} - ${formatExecutionDate(
    uniqueDates[uniqueDates.length - 1]
  )}`;
}

export function buildCourseCompletionReportFilename({
  title,
  schedules = []
} = {}) {
  const courseTitle = sanitizeFilenamePart(title, 'Pelatihan');
  const executionDate = sanitizeFilenamePart(formatBatchExecutionDate(schedules));
  const baseName = executionDate
    ? `Report_${courseTitle}_${executionDate}`
    : `Report_${courseTitle}`;

  const maxBaseLength = 180;
  const truncated =
    baseName.length > maxBaseLength
      ? baseName.slice(0, maxBaseLength).trim().replace(/[. ]+$/g, '')
      : baseName;

  return `${truncated}.xlsx`;
}
